export class SyncConfig {
  syncId: string;
  isFullSync: boolean;
  lastUploadTime: string;
  lastDownloadTime: string;
  project: number;
  //cai: string;  
  userId: number;
}
